/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  check: 'check_75dea6f9',
  owner: 'owner_75dea6f9',
  isSelected: 'isSelected_75dea6f9',
  isVisible: 'isVisible_75dea6f9',
  isDisabled: 'isDisabled_75dea6f9',
};

export = styles;

loadStyles([{"rawString":".check_75dea6f9{display:inline-block;cursor:default;box-sizing:border-box;vertical-align:top;background:0 0;border:none;opacity:0}.check_75dea6f9::-moz-focus-inner{border:0}.check_75dea6f9{outline:transparent}.check_75dea6f9{position:relative}.ms-Fabric.is-focusVisible .check_75dea6f9:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid "},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":"}.check_75dea6f9:focus{opacity:1}button.check_75dea6f9{padding:3px}.owner_75dea6f9.isSelected_75dea6f9 .check_75dea6f9,.owner_75dea6f9.isVisible_75dea6f9 .check_75dea6f9,.owner_75dea6f9:focus .check_75dea6f9,.owner_75dea6f9:hover .check_75dea6f9{opacity:1}.isDisabled_75dea6f9{visibility:hidden}"}]);
/* tslint:enable */